import { Injectable, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';

import * as L from 'leaflet';
import 'leaflet.pm';

@Injectable({
  providedIn: 'root'
})
export class MapConfigService {

  private map: any;
  private layerGroups: any[] = [];
  private activeLayerGroup: any;
  private center: L.LatLng;

  public layerGroupChanged = new Subject<L.LayerGroup>();

  constructor() { }

  public setActiveLayerGroup(): void {
    this.activeLayerGroup = L.featureGroup([]);
  }

  public setCenter(pos: Position): void {
    this.center = L.latLng([ pos.coords.latitude, pos.coords.longitude ]);
  }

  public createMap(mapElement: ElementRef) {
    const el = mapElement.nativeElement;

    this.map = L.map(el, {
      center: this.center,
      zoom: 10,
      layers: this.layerGroups
    });

    // use openstreetmap tiles as map information
    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    // add every newly created shape to the active layer
    this.map.on('pm:create', (e) => {
      this.activeLayerGroup.addLayer(e.layer);
      this.layerGroupChanged.next(this.activeLayerGroup);
    });

    // define toolbar options
    const options = {
      position: 'topleft', // toolbar position, options are 'topleft', 'topright', 'bottomleft', 'bottomright'
      drawMarker: false,  // adds button to draw markers
      drawPolygon: true,  // adds button to draw a polygon
      drawPolyline: false,  // adds button to draw a polyline
      editPolygon: true,  // adds button to toggle global edit mode
      deleteLayer: true   // adds a button to delete layerGroups
    };

    // add leaflet.pm controls to the map
    this.map.pm.addControls(options);
    // set lang to controls
    this.map.pm.setLang('en');
  }

  public getMap(): L.Map {
    return this.map;
  }

  public getActiveLayerGroup(): L.LayerGroup {
    return this.activeLayerGroup;
  }
}
